var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c("div", { staticClass: "popup" }, [
        _c("div", { staticClass: "content", attrs: { id: "appRecommend" } }, [
          _c("div", {
            staticClass: "app-recommend-close",
            on: {
              click: function($event) {
                return _vm.close()
              }
            }
          }),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "app-recommend-body" }, [
            _c("div", { staticClass: "app-recommend-title" }, [
              _vm._v(_vm._s(_vm.$t("language.popup.appRecommendPopup.title")))
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "app-recommend-tip",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("language.popup.appRecommendPopup.tip")
                )
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "app-recommend-btns" }, [
              _c(
                "div",
                {
                  staticClass: "app-recommend-btn",
                  on: {
                    click: function($event) {
                      return _vm.jumpToIosDownload()
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "app-recommend-btn-img icon-apple"
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "app-recommend-btn-tips" }, [
                    _vm.getbtnType("ios") == 1
                      ? _c("div", { staticClass: "app-recommend-btn-tip" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "language.popup.appRecommendPopup.iosBtnTitle"
                              )
                            )
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "app-recommend-btn-title" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("language.popup.appRecommendPopup.iosBtnTip")
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _vm.getbtnType("ios") == 2
                      ? _c("div", { staticClass: "app-recommend-btn-tip" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "language.popup.appRecommendPopup.iosBtnTitle"
                              )
                            )
                          )
                        ])
                      : _vm._e()
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "app-recommend-btn",
                  on: {
                    click: function($event) {
                      return _vm.jumpToAndroidDownload()
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "app-recommend-btn-img icon-google"
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "app-recommend-btn-tips" }, [
                    _vm.getbtnType("android") == 1
                      ? _c("div", { staticClass: "app-recommend-btn-tip" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "language.popup.appRecommendPopup.androidBtnTitle"
                              )
                            )
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "app-recommend-btn-title" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "language.popup.appRecommendPopup.androidBtnTip"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _vm.getbtnType("android") == 2
                      ? _c("div", { staticClass: "app-recommend-btn-tip" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "language.popup.appRecommendPopup.androidBtnTitle"
                              )
                            )
                          )
                        ])
                      : _vm._e()
                  ])
                ]
              )
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "app-recommend-left" }, [
      _c("div", { staticClass: "app-recommend-phone-img" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b873820", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b873820","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/activity_popups/app_recommend_popup.vue
// module id = null
// module chunks = 